// Finnish site is the default: root "/" shows the Finnish front page (no redirect).
export { default, getStaticProps } from './etusivu';
